// extracted by mini-css-extract-plugin
export default {"switch":"switch_switch__SEia5","active":"switch_active__z2k2y","circle":"switch_circle__Vm8sa"};